import { Row, Col, Form, Button } from 'antd';
import Feather from '@sysunite/react-feather'
import StringInput from './StringInput';

const ArrayInput = ({ initialValue = [], name }) => {

  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <>
          {fields.map((field) => (
            <Row key={field}>
              <Col span={23}>
                <Form.Item {...field}>
                  <StringInput
                    value={initialValue[field]}
                  />
                </Form.Item>
              </Col>
              <Col span={1}>
                <Button
                  data-testid="remove-attribute"
                  type="link"
                  onClick={() => remove(field.name)}
                >
                  <Feather type="x" />
                </Button>
              </Col>
            </Row>
          ))}
          <Form.Item>
            <Button
              data-testid="add-array-item"
              onClick={() => add()}
              type="dashed"
              block
            >
              <Feather type="plus" /> Add item
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  )
}

export default ArrayInput
